"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PresenceBadge: function() {
        return _index.PresenceBadge;
    },
    presenceAvailableFilled: function() {
        return _index.presenceAvailableFilled;
    },
    presenceAvailableRegular: function() {
        return _index.presenceAvailableRegular;
    },
    presenceAwayFilled: function() {
        return _index.presenceAwayFilled;
    },
    presenceAwayRegular: function() {
        return _index.presenceAwayRegular;
    },
    presenceBadgeClassNames: function() {
        return _index.presenceBadgeClassNames;
    },
    presenceBlockedRegular: function() {
        return _index.presenceBlockedRegular;
    },
    presenceBusyFilled: function() {
        return _index.presenceBusyFilled;
    },
    presenceDndFilled: function() {
        return _index.presenceDndFilled;
    },
    presenceDndRegular: function() {
        return _index.presenceDndRegular;
    },
    presenceOfflineRegular: function() {
        return _index.presenceOfflineRegular;
    },
    presenceOofRegular: function() {
        return _index.presenceOofRegular;
    },
    presenceUnknownRegular: function() {
        return _index.presenceUnknownRegular;
    },
    usePresenceBadgeStyles_unstable: function() {
        return _index.usePresenceBadgeStyles_unstable;
    },
    usePresenceBadge_unstable: function() {
        return _index.usePresenceBadge_unstable;
    }
});
const _index = require("./components/PresenceBadge/index");
